<template>
  <div>
    <v-menu
      offset-y
      min-width="290px"
      transition="scale-transition"
      v-model="menu"
      :disabled="disabled || readonly"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <div v-on="on" :class="{ 'flex-grow-1': grow }">
          <v-text-field
            v-bind="{ ...attrs }"
            :label="label"
            :placeholder="label"
            :disabled="disabled"
            :hide-details="hideDetails"
            :error-messages="errorMessages"
            :prepend-icon="disabled ? 'event_busy' : 'event'"
            :value="formatValue"
            @input="setDate($event, 'input')"
            @blur="$emit('blur', $event)"
            v-mask="'##.##.####'"
          />
        </div>
      </template>

      <v-date-picker
        no-title
        scrollable
        locale="ru"
        :value="datePickerValue"
        :type="type"
        :readonly="readonly"
        :disabled="disabled"
        :multiple="multiple"
        :min="min"
        :max="max"
        @input="setDate($event, 'picker')"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">Отменить</v-btn>
        <v-btn v-if="!hideClearBtn" text color="primary" @click="clearDateFilter">Очистить</v-btn>
        <v-btn text color="primary" @click="updateDateFilter">Применить</v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "DatePicker",

  props: {
    grow: { type: Boolean },
    dense: { type: Boolean },
    hideDetails: { type: Boolean, default: true },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    hideClearBtn: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    label: {
      type: String,
      default: "Укажите дату",
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    min: { type: String, default: null },
    max: { type: String, default: null },
    type: {
      type: String,
      default: "date",
      validator: function(value) {
        return ["date", "month"].indexOf(value) !== -1;
      },
    },
    value: {},
  },

  data() {
    return {
      menu: false,
      date: this.multiple ? [] : null,
    };
  },

  computed: {
    datePickerValue() {
      if (this.multiple) {
        return this.value;
      }

      const format = this.$date(this.value);
      if (format.isValid()) {
        return format.format("YYYY-MM-DD");
      }

      return this.value;
    },
    formatValue() {
      if (this.multiple) {
        return this.value;
      }

      const format = this.$date(this.value);
      if (format.isValid()) {
        return format.format("DD.MM.YYYY");
      }

      return this.value;
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.date = dayjs(val).format("YYYY-MM-DD");
      }
    },
  },
  created() {
    console.log(`this.date =>`, this.date);
    if (this.multiple && !this.value) {
      this.date = [];
    }
  },

  methods: {
    setDate(date, type) {
      console.log(`date =>`, date);

      if (this.multiple) {
        this.date = this.value;
      }

      if (type === "picker") {
        this.date = date;
        this.updateDateFilter();
      }
      if (type === "input") {
        const [DD, MM, YYYY] = date.split(".");
        if (date.length >= 10 && DD && MM && YYYY) {
          this.date = `${YYYY}-${MM}-${DD}`;
          this.updateDateFilter();
        }
      }
    },
    clearDateFilter() {
      this.menu = false;
      this.$emit("input", "");
      this.$emit("change", "");
    },

    updateDateFilter() {
      this.menu = false;
      this.$emit("input", this.date);
      this.$emit("change", this.date);
    },
  },
};
</script>

<style scoped></style>
